
// 获取浏览器?号后面的值
export let getQueryString = (name) => {
    let reg = new RegExp('[?&]' + name + '=([^&]*)', 'g')
	let value = null
    let arr = reg.exec(window.location.href)
    if (arr !== null) {
		try {
			value = window.decodeURIComponent(arr[1])
		} catch (e) {
			value = arr[1]
		}
	}
	value = value ? value.replace(/#\//, '') : value;
    return value;
}

// 获取url传递的参数 针对url #
export let getRequest2 = ()=>{
	let url_hash = window.location.hash;
	let url = decodeURI( url_hash.substring(url_hash.indexOf('?'), url_hash.length) );
	let theRequest = new Object();
	if (url.indexOf("?") != -1) {
		let str = url.substr(1);
		let strs = str.split("&");
		for (let i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
		}
	}
	return theRequest;
};

// 判断微信环境
export let isWeiXinFun = ()=>{
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true; // 微信环境
    }else{
        return false;
    }
};

// 判断app环境
export let isApp = ()=>{
	if( window.maxuslifeJS == undefined)
		return false;  // 非app环境
	else
		return true;  // app环境
}
  
// app分享
export let initAppShare = (shareData, shareCallback)=>{
	try {
		window.maxuslifeJS.functionDialog(JSON.stringify(shareData), 'shareResult');
		if (shareCallback && typeof (shareCallback) === 'function') {
			window.shareResult = function (status) {
				shareCallback(status);
			}
		}
	} catch (e) {
		console.log(e, "展示分享菜单");
	}
}

// 转化数组
export let conversionArr = (str) => {  
	let arr = str.split(",");
	arr.forEach((ele, index) => {
		if(ele.indexOf("/") != -1)
			arr.splice(index, 1, ele.split("/"))
	})
	console.log("mvvm02", arr);
	return arr;
}

//一个数组是否全包含另外一个素组
export let isInclude = (all, arr)  => { 
	let b = false;
	try {
		arr.forEach(ele => {
			if(ele instanceof Array){
				let a = false;
				ele.forEach(sub => { 
					if(all.includes(sub)) return a = true;
				})
				if(!a) {
					b = false;
					throw new Error('End Loop')
				}  
			} else {
				if(all.includes(ele)) b = true;
				else{
					b = false;   
					throw new Error('End Loop')
				}
			}
		});
		return b;
	} catch(e) {
		return b;
	}
}